module.exports = __webpack_public_path__ + "static/img/windows_img.5b6617c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/windows_img.png
// module id = VdaI
// module chunks = 1